import { NgModule } from '@angular/core';

// Pipes
import { RubsfilterPipe } from 'src/app/filters/rubs-filter.pipe';
import { ProdsFilterPipe } from 'src/app/filters/prods-filter.pipe';
import { DescFilterPipe } from 'src/app/filters/desc-filter.pipe';
import { PriceFilterPipe } from 'src/app/filters/price-filter.pipe';
import { CapitalizePipe } from 'src/app/filters/capitalize.pipe';
import { DateFilterPipe } from 'src/app/filters/date-filter.pipe';
import { NumPhonePipe } from 'src/app/filters/num-phone.pipe';
import { SheduleFilterPipe } from 'src/app/filters/shedule-filter.pipe';
import { HourFilterPipe } from 'src/app/filters/hour-filter.pipe';
import { RoundFilterPipe } from 'src/app/filters/round-filter.pipe';
import { ProdSizeFilter } from 'src/app/filters/prod-size-filter.pipe';
import { DiscountVipFilterPipe } from '../filters/prod-discount-vip-filter.pipe';
import { SearchFilterPipe } from '../filters/search-filter.pipe';


@NgModule({
  imports: [ /* Shared modules */],
  declarations: [

    // Pipes
    RubsfilterPipe,
    ProdsFilterPipe,
    DescFilterPipe,
    PriceFilterPipe,
    CapitalizePipe,
    DateFilterPipe,
    NumPhonePipe,
    SheduleFilterPipe,
    HourFilterPipe,
    RoundFilterPipe,
    ProdSizeFilter,
    DiscountVipFilterPipe,
    SearchFilterPipe

  ],
  providers: [],
  exports: [

    // Pipes
    RubsfilterPipe,
    ProdsFilterPipe,
    DescFilterPipe,
    PriceFilterPipe,
    CapitalizePipe,
    DateFilterPipe,
    NumPhonePipe,
    SheduleFilterPipe,
    HourFilterPipe,
    RoundFilterPipe,
    ProdSizeFilter,
    DiscountVipFilterPipe,
    SearchFilterPipe

  ]
})
export class CoreModule { }
